const columnsAllHelpdesk = [
  {
    title: "No.",
    key: "stt",
    dataIndex: "stt",
    scopedSlots: { customRender: "stt" },
    align: "center",
    width: 100,
  },
  {
    title: "Code",
    dataIndex: "code",
    key: "code",
    width: 125,
  },
  {
    title: "Title",
    key: "title",
    dataIndex: "title",
    scopedSlots: { customRender: "titleAgency" },
    sorter: (a, b) => a.title.localeCompare(b.title),
    width: 250,
  },
  {
    title: "Group",
    dataIndex: "group.name",
    width: 150,
  },
  {
    title: "Created at",
    key: "createdAt",
    dataIndex: "createdAt",
    scopedSlots: { customRender: "createdAt" },
    width: 150,
  },
  {
    title: "Updated at",
    key: "updatedAt",
    dataIndex: "updatedAt",
    scopedSlots: { customRender: "updatedAt" },
    width: 150,
  },
  {
    title: "",
    key: "action",
    scopedSlots: { customRender: "action" },
    width: 125,
  },
];

export { columnsAllHelpdesk };
